var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"icon":"fa-th-list","title":"Categorieën","standalone":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('ArticleCategoryTable')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }